


































import { Component, Vue } from "vue-property-decorator";
import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";

@Component({
	components: {},
	computed: {
		...mapGetters("users", ["userInfo"])
	}
})
export default class Dashboard extends Vue {
	userInfo!: any;
	dateId!: number;
	hour = 0;
	minute = 0;
	second = 0;

	mounted() {
		this.getHours();
	}
	destroyed() {
		clearInterval(this.dateId);
	}

	getHours() {
		this.dateId = setInterval(() => {
			this.hour = new Date().getHours();
			this.minute = new Date().getMinutes();
			this.second = new Date().getSeconds();
		}, 1000);
	}
}
